export default __webpack_public_path__ + "static/pnews_4-18ed609e56e9a69dfe3c0914231b2e1e.jpg";